export default "__VITE_ASSET__DAzjlZEd__"